import { type CoastStepState } from '../general/components/coast-step-icon';
import {
  APPLICATION_COMPLETE,
  APPLICATION_DENIED,
  APPLICATION_UNDER_REVIEW,
  BUSINESS_INFO_ONE,
  BUSINESS_INFO_TWO,
  COUNTER_OFFER,
  CREDIT_LOCKED,
  DOCUMENTS,
  FETCHING_BANK_DATA,
  FINANCIAL_STATEMENTS,
  GET_STARTED,
  PARTNER_ACCOUNT_CONFLICT,
  PERSONA,
  PERSONAL_INFO,
  PREQUALIFIED,
  PREVIEW_CARD,
  PRE_COLLECT_UBOS,
  REVIEW_APPLICATION,
  SPEND_INTENT,
  VERIFY_OTP,
  VERIFY_REVENUE,
  VERIFY_REVENUE_DOCS,
  VERIFY_REVENUE_MX,
} from '../paths';

export const STEP_LABELS = ['Business', 'People', 'Your offer', 'Finalize'] as const;

export type StepVector = readonly [CoastStepState, CoastStepState, CoastStepState, CoastStepState];

export const stepperStageMap: Partial<Record<string, StepVector>> = {
  [BUSINESS_INFO_ONE]: ['active', 'notReached', 'notReached', 'notReached'],
  [BUSINESS_INFO_TWO]: ['active', 'notReached', 'notReached', 'notReached'],
  [SPEND_INTENT]: ['active', 'notReached', 'notReached', 'notReached'],
  [PERSONAL_INFO]: ['done', 'active', 'notReached', 'notReached'],
  [PRE_COLLECT_UBOS]: ['done', 'active', 'notReached', 'notReached'],
  [FINANCIAL_STATEMENTS]: ['done', 'active', 'notReached', 'notReached'],
  [PREQUALIFIED]: ['done', 'done', 'active', 'notReached'],
  [PERSONA]: ['done', 'done', 'done', 'active'],
  [DOCUMENTS]: ['done', 'done', 'done', 'active'],
  [COUNTER_OFFER]: ['done', 'done', 'done', 'active'],
  [REVIEW_APPLICATION]: ['done', 'done', 'done', 'active'],
  [PREVIEW_CARD]: ['done', 'done', 'done', 'active'],
  [VERIFY_REVENUE]: ['done', 'done', 'done', 'active'],
  [VERIFY_REVENUE_MX]: ['done', 'done', 'done', 'active'],
  [VERIFY_REVENUE_DOCS]: ['done', 'done', 'done', 'active'],
  [APPLICATION_COMPLETE]: ['done', 'done', 'done', 'success'],
  [APPLICATION_DENIED]: ['done', 'done', 'done', 'rejected'],
  [CREDIT_LOCKED]: ['done', 'done', 'rejected', 'notReached'],
  [APPLICATION_UNDER_REVIEW]: ['done', 'done', 'done', 'pending'],
};

export const ROUTES_WITHOUT_STEPPER = new Set<string>([
  '*',
  GET_STARTED,
  VERIFY_OTP,
  PARTNER_ACCOUNT_CONFLICT,
  FETCHING_BANK_DATA,
]);

export const getStepperConfig = (pathname: string, override?: StepVector): StepVector | null => {
  if (override) {
    return override;
  }

  return stepperStageMap[pathname] ?? null;
};
